import { render, staticRenderFns } from "./intermediate-screen.vue?vue&type=template&id=b33b9830&scoped=true"
import script from "./intermediate-screen.vue?vue&type=script&lang=js"
export * from "./intermediate-screen.vue?vue&type=script&lang=js"
import style0 from "./intermediate-screen.vue?vue&type=style&index=0&id=b33b9830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33b9830",
  null
  
)

export default component.exports